export default __webpack_public_path__ + "static/media/logo.39582cb9.svg";